import ButtonWithEnter from '../components/button-with-enter';
import { SetupStepShell } from '../components/setup-step-shell';
import { fadeInUp } from '@up2promo-setup-frontend/ui/animations/fade-in-up.animation';
import { useDictionary } from '@up2promo-setup-frontend/ui/providers/dictionary.provider';
import { motion } from 'motion/react';
import { useSetupNavigation } from './hooks/use-setup-navigation';

export default function WelcomePage() {
  const translations = useDictionary();
  const { navigateTo } = useSetupNavigation();

  return (
    <SetupStepShell>
      <div className="flex flex-col gap-6 sm:gap-8">
        <div className="flex flex-col gap-2 sm:gap-3">
          <motion.h1
            custom={0}
            initial="hidden"
            animate="visible"
            variants={fadeInUp}
            className="text-2xl font-semibold tracking-tight text-foreground text-balance md:text-3xl lg:text-4xl"
          >
            {translations.pages.welcome.title}
          </motion.h1>
          <motion.p
            custom={1}
            initial="hidden"
            animate="visible"
            variants={fadeInUp}
            className="max-w-prose text-sm text-foreground/70 text-pretty md:text-base"
          >
            {translations.pages.welcome.description}
          </motion.p>
        </div>
        <motion.div
          custom={2}
          initial="hidden"
          animate="visible"
          variants={fadeInUp}
        >
          <ButtonWithEnter
            text={translations.pages.welcome.button}
            onClick={navigateTo.email}
          />
        </motion.div>
      </div>
    </SetupStepShell>
  );
}
